import EditAutomationModal from './EditAutomationModal';

export { EditAutomationAudioSelectionTypeModal } from './EditAutomationAudioSelection';
export { EditAutomationOutputModal } from './EditAutomationOutput';

export default EditAutomationModal;
